<template>
    <v-snackbar v-model="show" class="kut" color="transparent" content-class="kut-content" bottom right :timeout="-1">
        <toast-card clickable icon="mdi-update" @click.native="update" @close="dismiss">
            <div class="kut-body">
                <span class="kut-title">{{ $t('common.update_available') }}</span>
                <span class="kut-action">{{ $t('common.update_now') }}</span>
            </div>
        </toast-card>
    </v-snackbar>
</template>

<script>
import { mapState } from 'vuex'
import ToastCard from "@/components/common/ToastCard";
import { applyUpdate } from "@/registerServiceWorker";

export default {
    name: "KimsaUpdateToast",
    components: { ToastCard },
    computed: {
        ...mapState(['updateAvailable']),
        show: {
            get() {
                return this.updateAvailable
            },
            set(value) {
                if (!value) this.dismiss()
            },
        },
    },
    methods: {
        dismiss() {
            this.$store.commit('setUpdateAvailable', false)
        },
        update() {
            const vm = this
            if (!applyUpdate()) vm.dismiss()
        },
    },
}
</script>

<style scoped>
::v-deep .v-snack__wrapper {
    background: transparent !important;
    box-shadow: none !important;
    min-width: 0;
}

::v-deep .kut-content {
    padding: 0;
    width: 100%;
}

.kut ::v-deep .v-snack__wrapper {
    margin-bottom: calc(24px + var(--safe-area-inset-bottom, 0px));
    margin-right: 8px;
}

.kut-body {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.kut-title {
    font-size: var(--fs-input);
    font-weight: 500;
    line-height: 18px;
    color: var(--v-txtPrimary-base);
}

.kut-action {
    font-size: var(--fs-caption);
    font-weight: 600;
    line-height: 16px;
    color: var(--v-secondary-base);
}
</style>
